<template>
  <StadiumRankPicker />
  <ExtraOptionPicker />
  <PlatformPicker />
  <OptionPicker />
  <ChampionsPicker />
  <RolesPicker :select-only-one-role="true" />
</template>

<script setup>
import PlatformPicker from "../commonpickers/PlatformPicker.vue";
import OptionPicker from "./pickers/OptionPicker.vue";
import ChampionsPicker from "../commonpickers/ChampionsPicker.vue";
import RolesPicker from "../lol/pickers/RolesPicker.vue";
import ExtraOptionPicker from "./pickers/ExtraOptionPicker.vue";
import StadiumRankPicker from "./pickers/StadiumRankPickers.vue";

const gameStore = useGameStore();
const checkoutStore = useCheckoutStore();

const handleDetails = () => {
  const rank = [...gameStore.getGameRanks].slice(1)[0];

  checkoutStore.clearCheckout();
  checkoutStore.setServer("52");

  checkoutStore.setPlatform({
    platform: 1,
  });
  checkoutStore.setDetails({
    currentRankSlab: 1,
    currentRankTitle: "Rookie 5",
    desiredRankSlab: 2,
    desiredRankTitle: "Rookie 4",
  });
  checkoutStore.setGameAndPack({
    game: gameStore.getGame.id,
    pack: gameStore.getGamePack.id,
    fullGame: gameStore.getGame,
    fullPack: gameStore.getGamePack,
  });
};

handleDetails();

onNuxtReady(() => {
  checkoutStore.setCalculating();
});
</script>
